import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cls from 'classname';
import Icon from '../../../Icon';
import ProductDetailsCard from './ProductDetailsCard';
import { OverlayScrollbar } from '../../../Components/ScrollBar';
import utils from '../../../Utils/utils';
import ButtonComponent from '../../../Components/Button';
import openNotification from '../../../Components/Notification';
import './InterestBlock.less';

const skeletonList = [1, 2, 3, 4, 5];

const InterestBlock = (
  {
    skeleton,
    isMobile,
    product,
    onDownloadFile,
    onOpenUpgradePlan,
  }) => {

  /* field = path or audience */
  /* sort_type = descend or ascend */
  const [sort, setSort] = useState({ field: null, sort_type: null });
  const [isVisibleAll, setIsVisibleAll] = useState(false);

  const { t } = useTranslation();

  const interestsList = product?.interests?.length ? [...product?.interests] : [];
  const isLocked = product?.is_locked && interestsList.length > 3;

  const renderHeader = (<>
    <span className="title">{t('Interest Targeting')}</span>

    <span className={cls('link', { disabled: isLocked })}
          onClick={isLocked ? () => {
          } : onDownloadFile}
    >
      {
        isLocked ?
          <Icon role="icon" type="lock" />
          :
          <svg xmlns="http://www.w3.org/2000/svg"
               width="20"
               height="20"
               viewBox="0 0 20 20"
               fill="none"
          >
            <path
              d="M11.1138 2.7799L11.6441 2.24957L11.6441 2.24957L11.1138 2.7799ZM15.5542 7.22026L16.0845 6.68993L15.5542 7.22026ZM7.29232 18.4584C7.70653 18.4584 8.04232 18.1226 8.04232 17.7084C8.04232 17.2942 7.70653 16.9584 7.29232 16.9584V18.4584ZM12.709 16.9584C12.2948 16.9584 11.959 17.2942 11.959 17.7084C11.959 18.1226 12.2948 18.4584 12.709 18.4584V16.9584ZM10.7507 11.4584C10.7507 11.0442 10.4149 10.7084 10.0007 10.7084C9.58644 10.7084 9.25065 11.0442 9.25065 11.4584H10.7507ZM10.0007 16.6667L9.47032 17.1971C9.61097 17.3377 9.80174 17.4167 10.0007 17.4167C10.1996 17.4167 10.3903 17.3377 10.531 17.1971L10.0007 16.6667ZM12.6143 15.1137C12.9072 14.8209 12.9072 14.346 12.6143 14.0531C12.3214 13.7602 11.8465 13.7602 11.5537 14.0531L12.6143 15.1137ZM8.44765 14.0531C8.15475 13.7602 7.67988 13.7602 7.38699 14.0531C7.09409 14.346 7.09409 14.8209 7.38699 15.1137L8.44765 14.0531ZM5.62565 3.04175H9.93529V1.54175H5.62565V3.04175ZM15.2923 8.39877V16.0417H16.7923V8.39877H15.2923ZM10.5835 3.31023L15.0238 7.75059L16.0845 6.68993L11.6441 2.24957L10.5835 3.31023ZM4.70898 16.0417V3.95841H3.20898V16.0417H4.70898ZM7.29232 16.9584H5.62565V18.4584H7.29232V16.9584ZM14.3757 16.9584H12.709V18.4584H14.3757V16.9584ZM3.20898 16.0417C3.20898 17.3764 4.29096 18.4584 5.62565 18.4584V16.9584C5.11939 16.9584 4.70898 16.548 4.70898 16.0417H3.20898ZM16.7923 8.39877C16.7923 7.75783 16.5377 7.14314 16.0845 6.68993L15.0238 7.75059C15.1957 7.9225 15.2923 8.15566 15.2923 8.39877H16.7923ZM9.93529 3.04175C10.1784 3.04175 10.4116 3.13833 10.5835 3.31023L11.6441 2.24957C11.1909 1.79636 10.5762 1.54175 9.93529 1.54175V3.04175ZM15.2923 16.0417C15.2923 16.548 14.8819 16.9584 14.3757 16.9584V18.4584C15.7103 18.4584 16.7923 17.3764 16.7923 16.0417H15.2923ZM5.62565 1.54175C4.29096 1.54175 3.20898 2.62373 3.20898 3.95841H4.70898C4.70898 3.45215 5.11939 3.04175 5.62565 3.04175V1.54175ZM9.87565 2.70841V6.04175H11.3757V2.70841H9.87565ZM12.2923 8.45842H15.6257V6.95842H12.2923V8.45842ZM9.87565 6.04175C9.87565 7.37644 10.9576 8.45842 12.2923 8.45842V6.95842C11.7861 6.95842 11.3757 6.54801 11.3757 6.04175H9.87565ZM9.25065 11.4584V16.6667H10.7507V11.4584H9.25065ZM10.531 17.1971L12.6143 15.1137L11.5537 14.0531L9.47032 16.1364L10.531 17.1971ZM10.531 16.1364L8.44765 14.0531L7.38699 15.1137L9.47032 17.1971L10.531 16.1364Z"
              fill="#225AEA"
            />
          </svg>
      }
      {t('Export To CSV')}
      </span>
  </>);

  const renderHeaderSkeleton = (
    <div style={{padding: '24px 24px 8px', display: 'flex', alignItems: 'center', width: '100%'}}>
      <span className={'link skeleton'}
            style={{ width: 154, height: 28 }}
      />
      <span className={'link skeleton'}
            style={{ width: 91, height: 20, marginLeft: 'auto' }}
      />
    </div>
  );

  const handleChangeSort = (field) => {
    if (isLocked) return;
    if (sort.field !== field) {
      setSort({ field: field, sort_type: 'descend' });
    } else {
      if (sort.field === field) {
        if (sort.sort_type === 'descend') {
          setSort({ field: field, sort_type: 'ascend' });
        } else {
          setSort({ field: null, sort_type: null });
        }
      }
    }
  };

  function sortList(a, b) {
    if (sort['sort_type'] === 'descend') {
      return (a[sort.field] > b[sort.field] ? -1 : 1);
    } else if (sort['sort_type'] === 'ascend') {
      return (a[sort.field] > b[sort.field] ? 1 : -1);
    } else {
      return 0;
    }
  }

  function sortedList() {
    let result = interestsList.sort(sortList);
    if ((isMobile && !isVisibleAll) || isLocked) {
      return result.slice(0, 5);
    } else {
      return result;
    }
  }

  const handleChangeShow = () => {
    setIsVisibleAll(isVisibleAll => !isVisibleAll);
  };

  const memoizedList = useMemo(() => sortedList(),
    /*eslint-disable-next-line react-hooks/exhaustive-deps*/
    [sort.field, sort.sort_type, isVisibleAll, interestsList.length, product?.product_id]);

  if (skeleton) {
    return (<ProductDetailsCard
      header={renderHeaderSkeleton}
      withLine={!isMobile}
    >
      <div className="interest-card header-line">
        <div className="header-line-sort-item">
          <span className={'link skeleton'}
                style={{ width: 50, height: 20 }}
          />
        </div>
        <div className="header-line-sort-item">
          <span className={'link skeleton'}
                style={{ width: 70, height: 20 }}
          />
        </div>
      </div>
      <div className="interest-card-wrap"
           style={{display: 'flex', flexDirection: 'column', gap: 12}}
      >
        {
          skeletonList.map(el => (
            <div key={el} className="interest-card">
              <div className="interest-card-copy-text"
                   style={{display: 'flex', alignItems: 'center'}}
              >
                <span className={'link skeleton'}
                      style={{ width: utils.randomNum(50, 80), height: 20 }}
                />
                <span className={'link skeleton'}
                      style={{ width: 20, height: 20, marginLeft: 8 }}
                />
              </div>
              <span className={'link skeleton'}
                    style={{ width: utils.randomNum(40, 60), height: 20 }}
              />
            </div>
          ))
        }
      </div>
    </ProductDetailsCard>);
  } else {
    return (
      <ProductDetailsCard header={renderHeader}
                          withLine={!isMobile}
                          isLocked={isLocked}
                          onOpenUpgradePlan={onOpenUpgradePlan}
                          headerClassName={'interest-card-header'}
      >
        <div className="interest-card header-line">
          <div className="header-line-sort-item"
               onClick={() => handleChangeSort('name')}
          >
            <span>
              {t('Interests')}
            </span>
            <Icon type="arrow_downward" role="icon"
                  className={cls({
                    'icon-descend': sort['field'] === 'name' && sort['sort_type'] === 'descend',
                    'icon-ascend': sort['field'] === 'name' && sort['sort_type'] === 'ascend',
                  })}
            />
          </div>
          <div className="header-line-sort-item">
            <span>
              {t('Audience')}
            </span>
          </div>
        </div>
        <OverlayScrollbar>
          <div className={cls('interest-card-wrap', { 'show-all': isVisibleAll })}>
            {
              memoizedList.map((el, index) => (
                <div key={el.id}
                     className={cls('interest-card-value-wrap', { locked: el.is_locked })}
                >
                  <span className="interest-card-value interest-card-value-clickable"
                        onClick={() => {
                          navigator.clipboard.writeText(el.name);
                          openNotification({
                            message: `${el.name} was copied!`,
                            style: { minWidth: '716px' },
                          });
                        }}
                  >
                    {el.name}
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         fill="none"
                    >
                      <path
                        d="M12.7077 7.29175V3.33341C12.7077 2.75812 12.2413 2.29175 11.666 2.29175H3.33268C2.75739 2.29175 2.29102 2.75812 2.29102 3.33341V11.6667C2.29102 12.242 2.75739 12.7084 3.33268 12.7084H7.29102M8.33268 7.29175H16.666C17.2413 7.29175 17.7077 7.75812 17.7077 8.33342V16.6667C17.7077 17.242 17.2413 17.7084 16.666 17.7084H8.33268C7.75739 17.7084 7.29102 17.242 7.29102 16.6667V8.33342C7.29102 7.75812 7.75739 7.29175 8.33268 7.29175Z"
                        stroke="#225AEA"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="interest-card-value">
                    {utils.convertNumber(el?.audience, 2)}
                  </span>
                </div>
              ))}
          </div>
        </OverlayScrollbar>
        {
          isMobile && !isLocked ?
            (
              <ButtonComponent type="primary"
                               className={'btn-primary interest-card-show-interest-btn'}
                               onClick={handleChangeShow}
              >
                {t(isVisibleAll ? 'Show Less' : 'Show More')}
              </ButtonComponent>)
            : null
        }
      </ProductDetailsCard>
    );
  }
};

export default InterestBlock;
